const PRICE_FORMAT = {
  units: 'units',
  subUnits: 'subUnits',
  unitsAndSubUnits: 'unitsAndSubUnits',
};

const DIGITAL_WALLETS = {
  AMAZON_PAY: 'AMAZON_PAY',
  ANDROID_PAY: 'ANDROID_PAY',
  APPLE_PAY: 'APPLE_PAY',
  GOOGLE_PAY: 'GOOGLE_PAY',
  PAY_PAL: 'PAY_PAL',
  SHOPIFY_PAY: 'SHOPIFY_PAY',
};

const DIGITAL_WALLETS_TRACKING_KEY = {
  ANDROID_PAY: 'androidpay',
  APPLE_PAY: 'apple pay',
  GOOGLE_PAY: 'gpay',
  SHOPIFY_PAY: 'shopay',
  AMAZON_PAY: 'amazonpay',
  PAY_PAL: 'paypal',
};

export { PRICE_FORMAT, DIGITAL_WALLETS, DIGITAL_WALLETS_TRACKING_KEY };
